<template>
  <section :class="`yard-view-truck-${themeName}`">
    <svg-truck
      :background-color="getTruckThemeColor(assetVisit).backgroundColor"
      :border-color="getTruckThemeColor(assetVisit).borderColor"
      :scale="scale"
      :rotation="rotation"
      :class="$attrs.class"
      v-if="isAssetVisitWithoutContainers" />

    <svg-truck-asset-container
      :background-color="getTruckThemeColor(assetVisit).backgroundColor"
      :border-color="getTruckThemeColor(assetVisit).borderColor"
      :scale="scale"
      :rotation="rotation"
      :container-count="showContainerCount ? assetVisit.assetContainers?.length : 0"
      :class="$attrs.class"
      v-else-if="isAssetVisitLive" />

    <svg-truck-asset-container-striped
      :background-color="getTruckThemeColor(assetVisit).backgroundColor"
      :border-color="getTruckThemeColor(assetVisit).borderColor"
      :scale="scale"
      :rotation="rotation"
      :container-count="showContainerCount ? assetVisit.assetContainers?.length : 0"
      :class="$attrs.class"
      v-else />
  </section>
</template>

<script>
import { computed, defineComponent } from 'vue';

import useYard from '@/modules/yard/composables/useYard';
import SvgTruck from '@/components/svgs/SvgTruck.vue';
import SvgTruckAssetContainer from '@/components/svgs/SvgTruckAssetContainer.vue';
import SvgTruckAssetContainerStriped from '@/components/svgs/SvgTruckAssetContainerStriped.vue';
import { AssetVisitType } from '@nova/core';

export default defineComponent({
  name: 'YardViewTruck',
  components: { SvgTruck, SvgTruckAssetContainer, SvgTruckAssetContainerStriped },
  props: {
    assetVisit: {
      type: Object,
      required: false
    },
    rotation: {
      type: Number,
      default: 0 // Rotation degree (0, 90, 180, 270)
    },
    scale: {
      type: Number,
      default: 1
    },
    showContainerCount: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const yardStore = useYard();

    const isAssetVisitLive = computed(() => props.assetVisit?.visitType === AssetVisitType.Live);
    const isAssetVisitWithoutContainers = computed(
      () => !props.assetVisit?.assetContainers?.length
    );

    const themeName = computed(() => yardStore.getTruckThemeColor(props.assetVisit).theme);

    return {
      getTruckThemeColor: yardStore.getTruckThemeColor,
      themeName,
      AssetVisitType,
      isAssetVisitLive,
      isAssetVisitWithoutContainers
    };
  }
});
</script>
